import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createOnboardingSchemas } from 'shared/db/validation/schemas/onboarding';
import { Validator } from 'shared/db/validation/validator';
import { DeleteRawRecord, UpdateRawRecord } from 'shared/types/rawRecordFields';
import { OnboardingRawRecord } from 'shared/types/RsvpOnboarding';
import { OnboardingDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createOnboardingSchemas();

const addValidator = createDBEntityValidator<OnboardingRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<
    UpdateRawRecord<OnboardingRawRecord>
>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-onboardings'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createOnboardingsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const onboardingsInputValidation: OnboardingDBValidation = {
    add: createOnboardingsInputValidation(addValidator, validationStrategy),
    update: createOnboardingsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createOnboardingsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
